/*
 * <size-tip> — the "Conseil taille" link in the size-helper row (snippets/size-tip.liquid).
 *
 * Native <details> does the open/close and keyboard handling; this only adds the two things a
 * floating panel needs and <details> lacks: close on a click outside, and close on Escape
 * (returning focus to the link).
 *
 * The variant picker re-renders the size-helper row on variant change, which replaces this
 * element — hence the listeners are bound per instance and removed on disconnect.
 */
if (!customElements.get('size-tip')) {
  customElements.define(
    'size-tip',
    class SizeTip extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        if (!this.details) return;

        this.onDocumentClick = (event) => {
          if (this.details.open && !this.contains(event.target)) this.details.open = false;
        };
        this.onKeyUp = (event) => {
          if (event.key !== 'Escape' || !this.details.open) return;
          this.details.open = false;
          this.details.querySelector('summary')?.focus();
        };

        document.addEventListener('click', this.onDocumentClick);
        this.addEventListener('keyup', this.onKeyUp);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        this.removeEventListener('keyup', this.onKeyUp);
      }
    }
  );
}
